<template>
    <div class="menu-second">
        <div class="menu-second">
            <div class="menu-title">
                <span>积分</span>
            </div>
            <div class="menu-list">
                <div class="menu-item">
                    <router-link class="menu-item_title" :to="{path: '/app/points/setting.html'}">积分设置</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "left"
    }
</script>

<style scoped>

</style>
